import { Spinner } from "UI/Spinner";
import { MenuItem } from "components/Layout";
import { ReactComponent as SignOutIcon } from "images/logout-icon.svg";
import { loginStates } from "../../EmbeddedForm.hook";
import { LoginWindow } from "./LoginWindow";

export const LoginDriver = ({
  originator,
  loading,
  setError,
  setLoading,
  reloadAuthData,
  state,
  setState,
  hanldeLogout,
  flex = 0,
}) => {
  const handleLogin = () => {
    reloadAuthData();
    setState(loginStates.INFO);
  };

  if (!loading && !originator && state === loginStates.INFO) {
    return (
      <div
        className={`bg-blue-200 p-2 pl-4 w-full ${
          flex ? "flex-1" : ""
        } flex flex-row justify-between items-center gap-6 rounded-xl`}
      >
        <div className="text-sky-900">
          Already have a Referral Stream account?
        </div>
        <button
          className="bg-sky-700 flex-shrink-0 text-white font-bold py-2 px-4 rounded-xl hover:bg-gray-800"
          onClick={() => setState(loginStates.LOGIN)}
        >
          Log in
        </button>
      </div>
    );
  }

  if (!loading && !originator && state === loginStates.LOGIN) {
    const currentYear = new Date().getFullYear();

    return (
      <>
        <LoginWindow
          setState={setState}
          loading={loading}
          setError={setError}
          setLoading={setLoading}
          reloadAuthData={handleLogin}
        />
        <div className="fixed bottom-0 mb-4 text-gray-500 text-sm flex-grow-0 flex-shrink-0 text-center">
          Copyright © {currentYear} Referral Stream. All rights reserved.
        </div>
      </>
    );
  }

  return loading ? (
    <Spinner />
  ) : (
    <div className="flex flex-row justify-center items-center gap-2">
      <div>
        Welcome,{" "}
        <b>
          {originator?.firstName} {originator?.lastName}!
        </b>
      </div>
      {/* <div className="fixed top-2 right-2"> */}
      <MenuItem
        label="Sign out"
        icon={<SignOutIcon />}
        onClick={hanldeLogout}
      />
      {/* </div> */}
    </div>
  );
};
